module.exports = {
      id: "gears-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#gears",
      toString: function () {
        return this.url;
      }
    }